import { BadgeVariant } from '@property.com.au/ui-kit';
import { ResultOf } from 'gql.tada';
import { badgeFragment } from '../../graphql/fragments/badgeFragment';

type BadgeFragment = ResultOf<typeof badgeFragment>;

export const mapApiBadgeVariantToBadgeVariant = (
  variant: BadgeFragment['variant'],
): BadgeVariant => {
  switch (variant) {
    case 'GREEN':
      return 'green';
    case 'GREY':
      return 'grey';
    case 'YELLOW':
      return 'yellow';
    case 'BLUE':
      return 'blue';
    case 'RED':
      return 'red';
    case 'ORANGE':
      return 'orange';
    case 'PURPLE':
      return 'purple';
    case 'HIDDEN':
      return 'hidden';
    case 'CALLOUT':
      return 'callout';
    case 'WHITE':
      return 'white';
    default:
      return 'grey';
  }
};
